/* tslint:disable */
/* eslint-disable */
import { Observable } from "rxjs";
import { filter, map } from "rxjs/operators";

import { HttpClient, HttpContext, HttpResponse } from "@angular/common/http";

import { NameserverRead } from "../../models/nameserver-read";
import { NameserverUpdate } from "../../models/nameserver-update";
import { Status } from "../../models/status";
import { RequestBuilder } from "../../request-builder";
import { StrictHttpResponse } from "../../strict-http-response";

export interface UpdateNameserver$Params {
  organisation_id: string;
  nameserver_id: number;
  check?: boolean;
  body: NameserverUpdate;
}

export function updateNameserver(
  http: HttpClient,
  rootUrl: string,
  params: UpdateNameserver$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<NameserverRead | Status>> {
  const rb = new RequestBuilder(rootUrl, updateNameserver.PATH, "patch");
  if (params) {
    rb.path("organisation_id", params.organisation_id, {});
    rb.path("nameserver_id", params.nameserver_id, {});
    rb.query("check", params.check, {});
    rb.body(params.body, "application/json");
  }

  // add this header so we are able to examine the failure response
  // otherwise it's intercepted by the http interceptor
  rb.header("x-ignore-interceptor", "1");

  const responseType = "json";
  return http.request(rb.build({ responseType, accept: "application/json", context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<NameserverRead | Status>;
    }),
  );
}

updateNameserver.PATH = "/surfdomeinen/organisations/{organisation_id}/nameservers/{nameserver_id}";
